import { apiUserCall } from 'apps/investment/apiCalls/user';
import apiCall from 'apps/investment/apiCalls/userIdentification';
import { CreatePage, EditPage } from 'common/ui/AdminCRUD/page';
import ErrorMessage from 'common/ui/ErrorMessage';
import LoadingSpinner from 'common/ui/LoadingSpinner';
import { useFetchApiGet } from 'hooks/api';
import { useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import ItemBusinessForm from './BusinessForm';
import ItemIndividualForm from './user-individual-form';

// The edit URL no longer carries the account type, so read it from the user
// to pick the individual or business form.
export const InvestmentUserIdentificationEditPage = props => {
  const { userId, id } = useParams();
  const {
    data: user,
    isLoading,
    error,
    load,
  } = useFetchApiGet(apiUserCall.detail, { resourceName: 'data' });

  useEffect(() => {
    if (userId) load({ id: userId });
  }, [userId]);

  if (isLoading || (!user && !error)) return <LoadingSpinner />;
  if (error) return <ErrorMessage {...error} />;

  return (
    <EditPage
      title="User"
      apiCall={apiCall}
      listUrl={`/investment/users/${userId}/identifications/${id}`}
      ItemForm={
        user?.account_type == 'individual'
          ? ItemIndividualForm
          : ItemBusinessForm
      }
      options={{ title: 'Edit User Identification' }}
      resourceName="data"
      {...props}
    />
  );
};

// Old URL: /investment/users/:userId/identifications/:accountType/:id/edit
export const LegacyUserIdentificationEditRedirect = () => {
  const { userId, id } = useParams();
  return (
    <Navigate
      to={`/investment/users/${userId}/identifications/${id}/edit`}
      replace
    />
  );
};

export const InvestmentUserIdentificationCreatePage = props => {
  const params = useParams();

  return (
    <CreatePage
      title="User Identification"
      apiCall={apiCall}
      listUrl={`/investment/users`}
      ItemForm={
        params.accountType == 'individual'
          ? ItemIndividualForm
          : ItemBusinessForm
      }
      options={{ title: 'Create User Identification' }}
      resourceName="data"
      {...props}
    />
  );
};
